import ProFooter from "~/components/pro-footer/ProFooter";

export default {
    name: "Page",

    functional: true,

    components: { ProFooter },

    props: {
        behindNav: Boolean,
    },

    render(h, context) {
        return h(
            "div",
            {
                ...context.data,
                class: ["page-content", context.props.behindNav ? "page-content--behind-nav" : ""],
            },
            [
                h(
                    "main",
                    {
                        attrs: {
                            role: "main",
                            "aria-label": context.parent.$t("a11y-labels.main.content"),
                        },
                    },
                    context.slots().default
                ),
                h(ProFooter),
            ]
        );
    },
};
